import "./styles/App.scss";
import { Boost } from "./components/Boost";

function App() {
  return (
    <div className="App">
      <header className="App-header"></header>
      <main>
        <Boost />
      </main>
    </div>
  );
}

export default App;
